// M5 — Manager tour: Order Control. 6 steps on /ordercontrol.
// Chain: only surfaces in the welcome modal once A1 is completed (manual launch via ? menu still works).
export default {
  key: 'M5',
  route: '/ordercontrol',
  steps: [
    {
      id: 'overview',
      target: '[data-tour-id="ordercontrol.grid"]',
      title: 'Order Control',
      desc: 'A live dashboard of every active order and where each piece is in production.',
    },
    {
      id: 'rows',
      target: '[data-tour-id="ordercontrol.grid"]',
      title: 'Rows',
      desc: 'Each row is an order or an order position (product to be made).',
    },
    {
      id: 'columns',
      target: '[data-tour-id="ordercontrol.grid"]',
      title: 'Columns',
      desc: 'Columns are workcenter groups — the stations a position travels through.',
    },
    {
      id: 'cell-colors',
      target: '[data-tour-id="ordercontrol.grid"]',
      title: 'Cell colors',
      desc: 'Green = completed, yellow = in progress, blue = paused, red = overdue or at risk, empty = pending.',
    },
    {
      id: 'hover-tooltip',
      target: '[data-tour-id="ordercontrol.grid"]',
      title: 'Hover for details',
      desc: 'Hover over a cell to see the current action, worker, planned dates, and quantities.',
    },
    {
      id: 'search',
      target: '[data-tour-id="ordercontrol.search"]',
      title: 'Search & filter',
      desc: 'Filter the matrix to focus on a specific order, customer, or workcenter.',
    },
  ],
}
